module.exports = "/_next/static/images/e0bd75aa9e0a6fd91831f6f6a9759269-paperwork@desktop1366.jpg";